import { useLocation } from "@reach/router"
import { graphql, Link, useStaticQuery } from "gatsby"
import React, { useState } from "react"
import Helmet from "react-helmet"
import { ColorPalette } from "./theme"
import { Collapse, Row, Col, Container, Button } from "react-bootstrap"
import NavGroup from "./NavGroup"
import NavData from "../../content/nav.yaml"
import LDSiteNavigation from "../../content/ldSiteNavigation.json"
import LDWebSite from "../../content/ldWebSite.json"
import LDWebPage from "../../content/ldWebPage.json"
import LDOrganization from "../../content/ldOrganization.json"

/** svg */
import NorhartTextLogo from "../../assets/norhart-text-logo.svg"
import SignInIcon from "../../assets/sign-in.svg"
import NavNorhartLogo from "../../assets/nav-norhart-logo.svg"
import NavApartments from "../../assets/nav-apartments.svg"
import NorhartDarkCircleIcon from "../../assets/norhart-dark-circle-icon.svg"

/** props */
interface Props {
  colorPalette: ColorPalette
}

/** const */
const SiteNav: React.FC<Props> = (props) => {
  const [open, setOpen] = useState(false)
  const location = useLocation()
  const isHome = location.pathname === "/"
  const items = NavData.desktop

  let submenu
  for (const item of items) {
    if ("items" in item) {
      if (item.href == location.pathname) {
        submenu = item.items
        break
      }
      for (const subitem of item.items) {
        if (subitem.href == location.pathname) {
          submenu = item.items
          break
        }
      }
    }
  }

  return (
    <div>
      {isHome && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(LDSiteNavigation)}</script>
          <script type="application/ld+json">{JSON.stringify(LDWebSite)}</script>
          <script type="application/ld+json">{JSON.stringify(LDWebPage)}</script>
        </Helmet>
      )}

      <Helmet>
        <script type="application/ld+json">{JSON.stringify(LDOrganization)}</script>
      </Helmet>

      <div
        className="alert-light p-3 text-center alert-dismissible fade show "
        role="alert"
        style={{ marginBottom: "0px", height: "35px", lineHeight: "4px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-3" style={{ marginTop: "0px", textAlign: "left", paddingLeft: "20px" }}>
              <span className="d-none d-sm-block">
                <a
                  href="/apartments/"
                  target="_blank"
                  className="alert-link"
                  style={{ fontSize: "14px", textDecoration: "none" }}
                >
                  Now Leasing
                </a>
              </span>
            </div>

            <div className="col-6 d-none d-md-block">
              <a href="/careers/" className="alert-link"></a>
            </div>
            <div className="col-6 d-block d-md-none">
              <a href="/careers/" className="alert-link"></a>
            </div>

            <div className="col-3" style={{ marginTop: "-4px", textAlign: "right", paddingRight: "0px" }}>
              <div className="row">
                <div className="col d-none d-lg-block pt-1">
                  <a
                    href="https://norhart.twa.rentmanager.com/applynow"
                    target="_blank"
                    className="alert-link ps-1"
                    style={{ fontSize: "14px", textDecoration: "none" }}
                  >
                    Apply
                  </a>
                  <span className="ps-2"></span>
                  <span className="">|</span>
                  <span className="ps-2"></span>
                  <a
                    href="https://norhart.twa.rentmanager.com"
                    target="_blank"
                    className="alert-link ps-1"
                    style={{ fontSize: "14px", textDecoration: "none" }}
                  >
                    My Account
                  </a>

                  <span className="ps-2"></span>
                  <span className="">|</span>
                  <span className="ps-2"></span>

                  <a href="/blog/" className="alert-link ps-1" style={{ fontSize: "14px", textDecoration: "none" }}>
                    Blog
                  </a>
                </div>
              </div>

              <div className="row">
                <div className="col d-none d-sm-block d-md-block d-md-block d-lg-none">
                  <SignInIcon />{" "}
                  <a
                    href="https://norhart.twa.rentmanager.com"
                    target="_blank"
                    className="alert-link ps-1"
                    style={{ fontSize: "14px", textDecoration: "none" }}
                  >
                    Account
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav className="site-nav py-0" style={{ background: props.colorPalette.navTop }}>
        <div className="container d-flex flex-md-row justify-content-between align-items-center pt-1 pb-1">
          <a href="/" className="py-1 d-none d-lg-inline-block">
            <NorhartTextLogo />
          </a>

          {NavData.desktop.map((item, index) => (
            <h3 key={index} className="mb-0 d-none d-lg-inline-block">
              {item.target ? (
                <a className="p-0 nav-link" href={item.href} target={item.target}>
                  {item.name}
                </a>
              ) : (
                <Link
                  to={item.href}
                  className="p-0 nav-link"
                  getProps={({ isCurrent, location }) => {
                    let isActive = isCurrent

                    if (!isActive) {
                      if ("items" in item) {
                        for (const subitem of item.items) {
                          if (location.pathname == subitem.href) {
                            isActive = true
                            break
                          }
                        }
                      }
                    }

                    return isActive
                      ? {
                          style: {
                            fontWeight: 600,
                            opacity: 1.0,
                          },
                        }
                      : {}
                  }}
                >
                  {item.name}
                </Link>
              )}
            </h3>
          ))}

          <h3 className="pt-2 d-none d-lg-inline-block">
            <Button
              className="fw-bold ps-2 pe-2 animate__animated animate__bounce animate__slow"
              size="sm"
              variant="light"
              style={{
                margin: "12px",
                padding: "4px",
                opacity: "0.9",
                backgroundColor: "#FFFFFF",
                color: "#222222",
              }}
              href="https://norhart.twa.rentmanager.com/applynow"
              target="_blank"
            >
              Apply
            </Button>
          </h3>

          <a href="/apartments/" className="py-2 pt-2 d-block d-lg-none">
            <NavApartments />
          </a>

          <a href="/" className="py-2 d-block d-lg-none">
            <NavNorhartLogo />
          </a>

          <a
            className={`nav-toggle d-block d-lg-none mt-2 mb-2 ms-0 me-0 ${open ? "opened" : ""}`}
            onClick={() => setOpen(!open)}
            aria-controls="mobile-nav"
            aria-expanded={open}
            style={{ marginTop: "0px", border: "0px" }}
            role="main"
          >
            <span className="bar-top"></span>
            <span className="bar-mid"></span>
            <span className="bar-bot"></span>
          </a>
        </div>

        {submenu && (
          <div className="text-center" style={{ backgroundColor: props.colorPalette.subNav ?? "#77a4d9" }}>
            <div className="row chapternav d-none d-lg-block" style={{ width: "100%", height: "55px" }}>
              <div className="col-12 chapternav-wrapper animate__animated animate__fadeIn">
                <ul className="mt-3 subMenu-item chapternav-items">
                  {submenu.map((item, index) => (
                    <li key={index} className="subMenu-item">
                      <Link
                        to={item.href}
                        className="ps-3 pe-3 navTitle community-site-nav"
                        style={{ color: "#FFFFFF", opacity: 0.5 }}
                        activeStyle={{
                          fontWeight: "600",
                          opacity: "1.0",
                        }}
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}

        <div style={{ borderTop: `0.5px ${props.colorPalette.navBottom} solid` }}></div>
        <Collapse in={open}>
          <div id="mobile-nav" className="px-0 pt-3">
            <Container className="" style={{ width: "95%" }}>
              <Row>
                {NavData.mobile.map((cols, index) => {
                  return (
                    <Col key={index}>
                      {cols.map((col, index) => {
                        return (
                          <NavGroup key={index} className="w-85 ms-3">
                            {col.href ? (
                              <NavGroup.Header>
                                <a href={col.href}>{col.header}</a>
                              </NavGroup.Header>
                            ) : (
                              <NavGroup.Header>{col.header}</NavGroup.Header>
                            )}

                            <NavGroup.Content>
                              {col.items.map((item, index) => {
                                return (
                                  <NavGroup.Item key={index} href={item.href}>
                                    {item.name}
                                  </NavGroup.Item>
                                )
                              })}
                            </NavGroup.Content>
                          </NavGroup>
                        )
                      })}
                    </Col>
                  )
                })}
                <div className="container">
                  <div className="row text-center">
                    <a
                      href="https://norhart.twa.rentmanager.com/applynow"
                      target="_blank"
                      style={{ textDecoration: "none" }}
                    >
                      <div className="col-12 p-2 mb-3">
                        <div
                          className="p-2"
                          style={{ color: "#111111", backgroundColor: "#ffffff", fontWeight: "Bold" }}
                        >
                          Apply Now
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </Row>
            </Container>
          </div>
        </Collapse>
      </nav>

      <div
        style={{ background: props.colorPalette.navTop, borderBottom: `1px ${props.colorPalette.navBottom} solid` }}
      ></div>
      <div className="pb-0" style={{ background: props.colorPalette.navTop }}></div>
    </div>
  )
}

/** export */
export default SiteNav
